module.exports = __webpack_public_path__ + "img/download_tips.c92b3e14.png";